import duotone from 'icons/duotone';
import {
    PersonSearchTwoTone,
    LocalOfferTwoTone,
    LiveHelpTwoTone,
    Storefront,
    CardGiftcard,
    FolderSharedTwoTone,
    ShoppingBagTwoTone,
} from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material';
import type { ComponentType } from 'react';

export interface NavigationLabel {
    type: 'label';
    label: string;
    liOnly?: boolean;
}

export interface NavigationLink {
    name: string;
    icon?: ComponentType<SvgIconProps>;
    iconText?: string;
    path: string | string[];
    liOnly?: boolean;
    // Only shown with a program selected, not under All Programs.
    programOnly?: boolean;
    type?: 'extLink';
    badge?: { value: string | number };
    children?: NavigationLink[];
}

export type NavigationItem = NavigationLabel | NavigationLink;

export interface NavigationContext {
    adminConfig?: {
        li_dashboard?: {
            offer_management?: boolean;
            headerlogo?: string;
            [key: string]: boolean | string | number | undefined;
        };
        [key: string]: Record<string, boolean | string | number | undefined> | string | number | boolean | undefined;
    } | null;
}

export const navigations = (context: NavigationContext): NavigationItem[] =>
    (
        [
            {
                type: `label`,
                label: `Management`,
            },
            /** {
    name: `Home`,
    path: `/dashboard`,
    icon: duotone.PersonChalkboard,
  }, */
            {
                name: `Research`,
                icon: PersonSearchTwoTone,
                path: [`/dashboard/research`, `/dashboard/member`],
            },
            context?.adminConfig?.li_dashboard?.offer_management
                ? {
                      name: `Offers`,
                      icon: LocalOfferTwoTone,
                      path: `/dashboard/offers/findoffer`,
                  }
                : false,
            {
                name: `Reports`,
                icon: duotone.Pages,
                path: `/dashboard/reports`,
            },
            {
                name: `Health`,
                icon: duotone.Settings,
                path: `/dashboard/health`,
                liOnly: true,
            },
            {
                name: `Payouts`,
                icon: duotone.Pricing,
                path: `/dashboard/payouts`,
                liOnly: true,
            },
            context?.adminConfig?.li_dashboard?.offer_management
                ? {
                      name: `Inquiries`,
                      icon: LiveHelpTwoTone,
                      path: `/dashboard/inquiries`,
                      liOnly: true,
                  }
                : false,
            context?.adminConfig?.li_dashboard?.offer_management
                ? {
                      name: `Merchants`,
                      icon: Storefront,
                      path: `/dashboard/merchants`,
                      liOnly: true,
                  }
                : false,
            {
                name: `Gift Guide`,
                icon: CardGiftcard,
                path: `/dashboard/giftguide`,
                liOnly: true,
            },
            {
                name: `File Shares`,
                icon: FolderSharedTwoTone,
                path: `/dashboard/fileshares`,
                liOnly: true,
            },
            {
                name: `Products`,
                icon: ShoppingBagTwoTone,
                path: `/dashboard/products`,
                liOnly: true,
                programOnly: true,
            },
            {
                name: `External Coupons`,
                icon: ShoppingBagTwoTone,
                path: `/dashboard/externalcoupons`,
                liOnly: true,
            },
        ] as (NavigationItem | false)[]
    ).filter(Boolean) as NavigationItem[];
